module.exports = __webpack_public_path__ + "img/Manuel-14.f100b02a.jpg";